export const onClick = (
  infoPatient,
  countryPrefix,
  setErrors,
  callApiValidator
) => {
  if (
    !infoPatient.name ||
    !infoPatient.phoneNumber ||
    infoPatient.phoneNumber === countryPrefix
  ) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      fullName: !infoPatient.name,
      phoneNumber:
        !infoPatient.phoneNumber || infoPatient.phoneNumber === countryPrefix,
    }));
  } else {
    setErrors((prevErrors) => ({
      ...prevErrors,
      phoneNumber: false,
    }));
    callApiValidator();
  }
};

export const onChange = (
  event,
  infoPatient,
  setInfoPatient,
  setErrors,
  onChangeInfoPatient
) => {
  const { value, name } = event.target;
  const updatedInfoPatient = {
    ...infoPatient,
    [name]: value,
  };
  setInfoPatient(updatedInfoPatient);

  setErrors((prevErrors) => ({
    ...prevErrors,
    [name]: false,
  }));

  onChangeInfoPatient(updatedInfoPatient);
};

export const onBlur = (
  event,
  fieldName,
  countryData,
  setCountryPrefix,
  infoPatient,
  setInfoPatient,
  setErrors,
  onChangeInfoPatient
) => {
  setCountryPrefix("+" + countryData.dialCode + "#");
  const prefix = "+" + countryData.dialCode;
  if (fieldName === undefined) {
    return;
  }
  const { value } = event.target;
  const fieldValue = value;

  let numWihtOutSpace = fieldValue.replace(/\s/g, "");
  let numWhitOutPrefix = numWihtOutSpace.replace(prefix, "");
  let completeNumber = `${prefix}#${numWhitOutPrefix}`;

  const updatedInfoPatient = {
    ...infoPatient,
    [fieldName]: completeNumber,
  };
  setInfoPatient(updatedInfoPatient);

  setErrors((prevErrors) => ({
    ...prevErrors,
    [fieldName]: false,
  }));

  onChangeInfoPatient(updatedInfoPatient);
};
